/** Fit-to-width scaling for the editor's page canvas. */

export const MIN_CANVAS_SCALE = 0.4

/**
 * The scale that fits a `pageWidth` page into `availableWidth` (the scroll container's content
 * box). Never enlarges past 1, never shrinks below MIN_CANVAS_SCALE; an unmeasured (0) container
 * leaves the page at full size.
 */
export function fitToWidthScale(availableWidth: number, pageWidth: number): number {
  if (!(availableWidth > 0) || !(pageWidth > 0) || availableWidth >= pageWidth) return 1
  return Math.max(MIN_CANVAS_SCALE, Math.floor((availableWidth / pageWidth) * 1000) / 1000)
}
